<template>
  <div class="radio-group">
    <label v-for="(option, index) in options" :class="{selected: innerValue==option[settings.valueProp], interactive: !disabled, disabled: disabled}">
      <input type="radio" :name="name || 'radio'+stamp" :value="option[settings.valueProp]" v-model="innerValue" @change="updateValue" :disabled="disabled">
      <slot :name="'bullet-'+index">
        <span class="bullet">{{ intervalChar(index+1) }}</span>
      </slot>
      <div class="option-text">
        {{ option[settings.labelProp] }}
        <slot :name="'lower-'+index" />
      </div>
    </label>
  </div>
</template>

<script>

  export default {
    name: 'RadioGroup',
    props: {
      value: {},
      name: {
        type: String
      },
      options: {
        type: Array,
        required: true
      },
      config: {
        type: Object,
        default () {
          return {}
        }
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        innerValue: this.value,
        settings: {
          labelProp: 'value',
          valueProp: 'response'
        },
        stamp: new Date().getTime()
      }
    },
    created () {
      _.assign(this.settings, this.config)
    },
    methods: {
      intervalChar (int) {
        return String.fromCharCode(64 + +int)
      },
      updateValue () {
        this.$emit('input', this.innerValue)
      }
    },
    watch: {
      value (val) {
        this.innerValue = val
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  label {
    @include transition();
    display:flex; align-items:center; width:100%; padding:1rem 2rem; border-radius:4px; border:1px dashed $color-primary-darker; line-height:1.3;
    &.disabled {
      cursor:auto;
    }
    &.interactive {
      &:hover, &:focus {
        background-color:$color-white; border-color:$color-primary;
      }
    }
    &.selected {
      background-color:$color-white; border-color:$color-primary; border-style:solid;
    }
  }

  label+label {
    margin-top:2rem;
  }

  input {
    appearance:none; position:absolute; left:-9999px;
  }

  .bullet {
    @include bullet();
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/radio-group.vue